var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('span',[_vm._v("\n  "+_vm._s(_vm.displayDate)),(_vm.split)?_c('br'):_vm._e(),(!_vm.split && _vm.showTime)?_c('span',[_vm._v(", ")]):_vm._e(),_vm._v(" "),(_vm.showTime)?_c('span',[_vm._v(_vm._s(_vm.displayTime))]):_vm._e()]):_c('span',[_vm._v("\n  --\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63fc3c72","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/node_modules/vue-loader/lib/selector.js?type=template&index=0!/src/components/utility/NiceDate.vue
// module id = null
// module chunks = 